import AuthErrorCodes from "domain/auth/AuthErrors";
import GiftCardsErrors from "domain/giftcards/GiftCardsErrors";
import OrganizationErrorsCodes from "domain/organization/OrganizationErrors";
import PointErrorCodes from "domain/point/PointErrors";
import UserErrorCodes from "domain/user/UserErrors";

export enum GenericErrorCodes {
    UNKNOWN_ERROR = "UNKNOWN_ERROR",
    BAD_REQUEST = "BAD_REQUEST",
}

// Define Backend Api possible error codes
enum AppErrorCodes {
    INVALID_IMAGE = "INVALID_IMAGE",
    ORGANIZATION_NOT_FOUND = "ORGANIZATION_NOT_FOUND",
    PROGRAM_NOT_FOUND = "PROGRAM_NOT_FOUND",
    WALLET_NOT_FOUND = "WALLET_NOT_FOUND",
    INVALID_WALLET = "INVALID_WALLET",
    PARTNER_NOT_FOUND = "PARTNER_NOT_FOUND",
    USER_ALREADY_IN_ORGANIZATION = "USER_ALREADY_IN_ORGANIZATION",
    FORBIDDEN = "FORBIDDEN",
    INVALID_ROLE_TYPE = "INVALID_ROLE_TYPE",
    INSUFFICIENT_TOKEN_AMOUNT = "INSUFFICIENT_TOKEN_AMOUNT",
    RECEIVER_NOT_FOUND = "RECEIVER_NOT_FOUND",
    ORGANIZATION_HAS_NO_TERMS = "ORGANIZATION_HAS_NO_TERMS",
    IDENTIFICATION_CODE_INVALID = "IDENTIFICATION_CODE_INVALID",
    ROLE_NOT_FOUND = "ROLE_NOT_FOUND",
    EMPTY_FILE = "EMPTY_FILE",
    USER_NOT_IN_ORGANIZATION = "USER_NOT_IN_ORGANIZATION",
    NOT_FOUND = "NOT_FOUND",
    APPROVER_NOT_FOUND = "APPROVER_NOT_FOUND",
    APPROVER_ALREADY_EXISTS = "APPROVER_ALREADY_EXISTS",
    RELEASE_STRATEGY_NOT_FOUND = "RELEASE_STRATEGY_NOT_FOUND",
    TEMPLATE_MANDATORY_FIELDS_MISSING = "TEMPLATE_MANDATORY_FIELDS_MISSING",
    FILE_TYPE_NOT_SUPPORTED = "FILE_TYPE_NOT_SUPPORTED",
    FILE_SIZE_EXCEEDED = "FILE_SIZE_EXCEEDED",
    FILE_PROCESSING_ERROR = "FILE_PROCESSING_ERROR",
    INVALID_TEMPLATE_ROW = "INVALID_TEMPLATE_ROW",
    INVALID_TEMPLATE_COLUMNS = "INVALID_TEMPLATE_COLUMNS",
    PARTNER_BELONGS_TO_OTHER_ALLY = "PARTNER_BELONGS_TO_OTHER_ALLY",
}

// Merge all module error codes here
const DomainErrorCodes = {
    ...GenericErrorCodes,
    ...GiftCardsErrors,
    ...AppErrorCodes,
    ...AuthErrorCodes,
    ...UserErrorCodes,
    ...PointErrorCodes,
    ...OrganizationErrorsCodes,
};

export type DomainErrorCode = keyof typeof DomainErrorCodes;

export default DomainErrorCodes;
